import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

/**
 * Redirects /connectors/:sourceSlug/:destinationSlug to canonical /integrations/:sourceSlug/to/:destinationSlug
 */
export function RedirectConnectorsPair() {
    const { sourceSlug, destinationSlug } = useParams();
    if (!sourceSlug || !destinationSlug) return <Redirect to="/integrations" />;
    return <Redirect to={`/integrations/${sourceSlug}/to/${destinationSlug}`} />;
}

/**
 * Parses "source-to-destination" slug and redirects to /integrations/:sourceSlug/to/:destinationSlug.
 * Used for /sync/:sourceToDestSlug and /export/:sourceToDestSlug.
 */
export function RedirectSlugToPair() {
    const { sourceToDestSlug } = useParams();
    if (!sourceToDestSlug || !sourceToDestSlug.includes('-to-')) {
        return <Redirect to="/integrations" />;
    }
    const parts = sourceToDestSlug.split('-to-');
    if (parts.length < 2) return <Redirect to="/integrations" />;
    const sourceSlug = parts[0];
    const destSlug = parts.slice(1).join('-to-');
    return <Redirect to={`/integrations/${sourceSlug}/to/${destSlug}`} />;
}
